module.exports = __webpack_public_path__ + "img/hmg1.d8feac44.png";